import React, { createElement } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash/fp';
import classNames from 'classnames';
import { TYPES } from 'constants/config';
import * as selectors from 'selectors/pathBuilder';
import BlankView from './BlankView';
import Adder from './Adder';
import Content from './Content';
import WaitStep from './WaitStep';
import Placeholder from './Placeholder';
import StepsConnector from './StepsConnector';

const typeToComponent = {
  [TYPES.LESSON]: Content,
  [TYPES.PATH]: Content,
  [TYPES.WAITSTEP]: WaitStep,
  [TYPES.PLACEHOLDER]: Placeholder,
  [TYPES.DEMONSTRATION]: Content,
  [TYPES.CERTIFICATION]: Content,
};

const renderAdder = idx => (
  <Adder key={`adder_${idx + 1}`} position={idx + 1} />
);

const renderElement = (item, index) =>
  createElement(typeToComponent[item.type], {
    key: `${item.type}.${item.id}`,
    ...item,
    index,
  });

const renderContents = contents =>
  contents.reduce(
    (items, item, i) => [...items, renderElement(item, i), renderAdder(i + 1)],
    [renderAdder(0)],
  );

const ContentList = ({
  contents,
  canEditPath,
  pathId,
  editingMode,
  isArchived,
}) => {
  const hasContent = !isEmpty(contents);
  const listClassName = classNames('PathContentsList', {
    'PathContentsList--editing': editingMode,
    'PathContentsList--view': !editingMode,
    'PathContentsList--empty': !hasContent,
  });

  return (
    <div className={listClassName}>
      {hasContent && renderContents(contents)}
      {(!pathId || canEditPath) && !hasContent && !isArchived && <BlankView />}
      <StepsConnector />
    </div>
  );
};

const mapStateToProps = state => ({
  contents: state.pathBuilder.contents,
  canEditPath: state.pathBuilder.permissions.editPath,
  pathId: state.pathBuilder.id,
  editingMode: selectors.modeSelectors.isEdit(state.pathBuilder),
  isArchived: selectors.isArchived(state.pathBuilder),
});

export default connect(mapStateToProps)(ContentList);
